import {CameraIcon} from "../CameraIcon";
import React from "react";

export const CpeMacAddressInput = ({technicalData, onChange, startBarcodeScanning, errors}) => {
  const updateUnitTechnicalComponent = (event) => {
    onChange('cpe.mac_address', event.target.value);
  }

  const handleScan = () => {
    startBarcodeScanning('cpe.mac_address');
  }
  
  const hasError = errors && errors.length !== 0;
  
  return (
      <>
        <h6 className="text-xs font-bold text-gray-600 uppercase">CPE</h6>
        <div>
          <label
              className="block text-xs text-gray-600 mb-1">MAC-Adresse</label>
          <div className="flex items-center space-x-2">
            <input
                type="text"
                value={technicalData?.cpe?.mac_address}
                onChange={updateUnitTechnicalComponent}
                className={`flex-1 px-2 py-1 text-xs border rounded focus:outline-none focus:ring-1 ${
                    hasError
                        ? "border-red-500 focus:ring-red-500"
                        : "border-gray-300 focus:ring-orange-500"
                }`}
                placeholder="MAC-Adresse"
            />
            <button
                type="button"
                onClick={handleScan}
                className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-md transition-colors"
                title="Barcode scannen"
            >
              <CameraIcon/>
            </button>
          </div>
          {hasError && (
              <p className="mt-1 text-xs text-red-500">{errors[0].defaultMessage}</p>
          )}
        </div>
      </>);
};